// Sprint DISC — shared Claude Design / Phase 2.5 constants.
//
// The five artefact types that constitute a complete Phase 2.5 design system.
// Defined once here so DISC.B1's "Ready for Claude Design" banner, DISC.B2's
// bundle stage tracker, and DISC.A3's export-disable gate all derive "Phase
// 2.5 complete" from a single list — instead of importing it out of the
// 2600-line ProjectDashboardPage module (where the same set lives as
// PHASE_ARTEFACT_TYPES['phase_2_5_ux_design'] / ARTEFACT_PHASE_MAP).
export const PHASE_25_ARTEFACT_TYPES = [
  'user_journey_map',
  'screen_inventory',
  'screen_spec',
  'component_catalogue',
  'design_tokens',
] as const;

/**
 * True only when EVERY Phase 2.5 artefact type is present AND approved.
 *
 * NOTE: the issue body phrased this as
 *   `artefacts.filter(a => TYPES.includes(a.type)).every(a => a.status === 'approved')`
 * which is vacuously TRUE for a project with zero Phase 2.5 artefacts
 * (`[].every(...)` === true) — it would fire the banner before any UX work
 * exists. We require each of the five types to have an approved artefact, so
 * an empty / partial set correctly reads as incomplete.
 */
export function isPhase25Complete(
  artefacts: ReadonlyArray<{ type: string; status: string }>,
): boolean {
  return PHASE_25_ARTEFACT_TYPES.every(type =>
    artefacts.some(a => a.type === type && a.status === 'approved'),
  );
}
